/*
  Yatay ürün raflarına (.product-scroll) ok butonu ve taşma göstergesi ekler.

  Raflar CSS ile zaten kaydırılabilir, ancak kaydırma çubuğu gizli olduğu için
  fare kullanan ziyaretçi rafın devam ettiğini göremiyor ve kaydıramıyordu.
  Bu dosya ilerleyici bir iyileştirmedir: betik çalışmazsa raflar dokunmatikte
  ve klavyeyle eskisi gibi kaydırılmaya devam eder.
*/
(function () {
  var READY_ATTR = 'data-rail-ready';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function arrow(dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-rail__nav product-rail__nav--' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Önceki ürünler' : 'Sonraki ürünler');
    btn.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
      ' stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="' + (dir === 'prev' ? '15 5 8 12 15 19' : '9 5 16 12 9 19') + '"/></svg>';
    return btn;
  }

  function setup(scroller) {
    if (scroller.getAttribute(READY_ATTR)) return;
    scroller.setAttribute(READY_ATTR, 'true');

    var rail = document.createElement('div');
    rail.className = 'product-rail';
    scroller.parentNode.insertBefore(rail, scroller);
    rail.appendChild(scroller);

    var prev = arrow('prev');
    var next = arrow('next');
    rail.appendChild(prev);
    rail.appendChild(next);

    /* Kaydırma olayı çok sık tetiklendiği için durum güncellemesi bir sonraki
       çizim karesine bırakılır. */
    var pending = false;

    function update() {
      pending = false;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var overflows = max > 1;

      /* Taşma yoksa oklar erişilebilirlik ağacından da çıkarılır. */
      prev.hidden = !overflows;
      next.hidden = !overflows;
      if (!overflows) return;

      /* Uçlardaki ok devre dışı bırakılır; CSS onu tamamen saydamlaştırdığı
         için kenardaki kartın üstünü gereksiz yere kapatmaz. */
      var x = scroller.scrollLeft;
      prev.disabled = x <= 1;
      next.disabled = x >= max - 1;
    }

    function queueUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(update);
    }

    function step(sign) {
      /* Bir kart kadar değil, görünen genişliğin tamamına yakın kaydırılır;
         böylece her tıklama yeni bir "sayfa" getirir. */
      var card = scroller.querySelector('.product-card-wrap');
      var amount = Math.max(
        card ? card.offsetWidth * 2 : 0,
        Math.round(scroller.clientWidth * 0.85)
      );
      scroller.scrollBy({
        left: sign * amount,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    scroller.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate);

    /* Kart görselleri yüklendikçe raf genişliği değişebilir. */
    if (window.ResizeObserver) {
      new ResizeObserver(queueUpdate).observe(scroller);
    }

    update();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var rails = scope.querySelectorAll('.product-scroll');
    for (var i = 0; i < rails.length; i++) setup(rails[i]);
  }

  /* Ürün önerileri gibi sonradan eklenen raflar için dışarıya açılır. */
  window.vivendaRails = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
